(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeCanceledOrdersTable', function ($Orders, $uibModal, $pageArray, $timeout, uiGridConstants, uiGridGroupingConstants) {
		return {
			scope: {
				store: '='
			},
			templateUrl: 'directives/storeCanceledOrdersTable/table.html',
			controller: function($scope) {

                $scope.init = function () {

                    $Orders.all($scope.store).then(function(orders) {

                        let gridData = [];

                        // let's do some loop-de-loops and make the data useful

                        _.forEach(orders, (order, key) => {

                            if(order.orderStatus !== 'Canceled') return;

                            let gridOrder = {

                                orderId: key,
                                orderedBy: order.checkoutDetails.orderedBy,
                                email: order.checkoutDetails.email,
                                phone: order.checkoutDetails.phone,
                                orderedFor: order.checkoutDetails.orderedFor || 'N/A',
                                numOfProducts: countAllProductsAndProductsInPackages(order),
                                numOfPackages: countAllPackages(order),
                                paymentType: order.checkoutDetails.paymentType,
                                // paymentType: readablePaymentMethod(order.checkoutDetails.paymentType),
                                status: order.status,
                                total: order.total

                            }

                            gridData.push(gridOrder)

                        });

                        $scope.gridOptions.data = gridData;

                    });

                };

                $scope.selectOrder = (order) => {

                    // console.log('order', order, $scope.store);
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'directives/orderDetail/section.html',
                        windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                        controller: 'OrderDetailController',
                        resolve: {
                            orderDetails: function() {
                                return $Orders.getOrderByStore($scope.store.$id, order.orderId).then( (orderDetails) => {
                                    console.log('the deets', orderDetails);
                                    return orderDetails;
                                });
                            }
                        },
                        size: 'lg'
                    });

                };

                $scope.gridOptions = {
                    columnDefs: [
                        {
                            name: 'orderId',
                            displayName: 'Order Id',
                            // enableCellEdit: false
                        },
                        {
                            name: 'orderedBy',
                            displayName: 'Ordered By',
                            // enableCellEdit: true
                        },
                        {
                            name: 'email',
                            displayName: 'Email',
                            // enableCellEdit: true
                        },
                        {
                            name: 'phone',
                            displayName: 'Phone',
                            // enableCellEdit: true
                        },
                        {
                            name: 'orderedFor',
                            displayName: 'Ordered For',
                            // enableCellEdit: true
                        },
                        {
                            name: 'numOfProducts',
                            displayName: 'Num Of Products',
                            // enableCellEdit: false
                        },
                        {
                            name: 'numOfPackages',
                            displayName: 'Num Of Packages',
                            // enableCellEdit: false
                        },
                        {
                            name: 'paymentType',
                            displayName: 'Payment Type',
                            // enableCellEdit: true,
                            // editableCellTemplate: 'ui-grid/dropdownEditor',
                            // width: '20%',
                            cellFilter: 'mapPaymentType',
                            // editDropdownValueLabel: 'paymentType',
                            // editDropdownOptionsArray: [
                            //     {
                            //         id: 'check',
                            //         paymentType: 'Check'
                            //     },
                            //     {
                            //         id: 'credit',
                            //         paymentType: 'Credit Card'
                            //     },
                            //     {
                            //         id: 'org',
                            //         paymentType: 'School/Organization'
                            //     }
                            // ]
                        },
                        {
                            name: 'status',
                            displayName: 'Status',
                            // enableCellEdit: true
                        },
                        {
                            name: 'total',
                            displayName: 'Total',
                            // enableCellEdit: false
                        }
                    ],
                    enableCellEdit: false,
                    enableSorting: true,
                    enableColumnResizing: true,
                    enableFiltering: true,
                    showGridFooter: true,
                    showColumnFooter: true,
                    fastWatch: true,
                    enableGridMenu: true,
                    enableSelectAll: true,
                    exporterCsvFilename: $scope.store.name + '.csv',
                    exporterMenuPdf: false,
                    exporterCsvLinkElement: angular.element(document.querySelectorAll(".custom-csv-link-location")),
                    onRegisterApi: function(gridApi){
                      $scope.gridApi = gridApi;
                      $scope.gridApi.core.addRowHeaderColumn( { name: 'rowHeaderCol', displayName: '', width: 30, cellTemplate: '<div class="ui-grid-cell-contents"><a class="grid-anchor" ng-click="grid.appScope.selectOrder(row.entity)"><i class="fa fa-search"></i></a></div>' } );

                      $scope.gridApi.edit.on.afterCellEdit($scope,function(rowEntity, colDef, newValue, oldValue){
                          console.log('afterCellEdit', rowEntity, colDef, newValue, oldValue);
                        $scope.$apply();
                      });

                    },
                };

                $scope.init();



				$scope.add = function() {
                    console.log('nothing, adding this, whatever add order thing it is, did nothing');
					// $Orders.add({
					// 	store: $scope.store ? $scope.store.$id : null,
					// 	customer: 'Stephan Smith',
					// 	date: '12/1/2018',
					// 	paymentStatus: 'pending',
					// 	paymentMethod: 'check',
					// 	total: 125.00,
					// 	numOfItems: 10,
					// 	items: []
					// });
				};

                // function readablePaymentMethod(paymentMethod) {
                //
                //     switch (paymentMethod) {
                //         case 'credit':
                //             return 'Credit Card';
                //         case 'check':
                //             return 'Check';
                //         case 'org':
                //             return 'School/Organization'
                //         default:
                //             break;
                //     }
                //
                // };

                function countAllPackages(order){

                    let packageCount = 0;

                    _.forEach(order.packages, function(productPackage) {
                        packageCount++;
                    });

                    return packageCount;

                }

                function countAllProductsAndProductsInPackages(order){

                    let productCount = 0;

                    _.forEach(order.products, () => {
                        productCount++;
                    });


                    _.forEach(order.packages, function(productPackage) {

                        _.forEach(productPackage.products, () => {
                            productCount++;
                        });
                    });

                    return productCount;

                }

			}
		};
	});

    ngModule.filter('mapPaymentType', function() {
        var paymentTypeHash = {
            'check':'Check',
            'credit':'Credit Card',
            'org':'School/Organization'
        }

        return function(input) {
            if (!input){
                return '';
            } else {
                return paymentTypeHash[input];
            }
        };
    })

})();
